import { SVG, getDefaultHeight } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const DocumentIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 26)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path d="M1 1h24v24H1Z" />
      <path d="M10.6 5.8h9.6" />
      <path d="M5.8 15.4h14.4" />
      <path d="M5.8 10.6h14.4" />
      <path d="M5.8 20.2h8" />
    </SVG>
  );
};
